<app-capture-history-item-title>
  Associated Patient Interaction Location Added
</app-capture-history-item-title>

<app-capture-history-item-body>
  {{ note }}
</app-capture-history-item-body>
